import React, { useState } from "react";
import { FaArrowLeft, FaSignInAlt } from "react-icons/fa";
import {FiEye, FiEyeOff } from "react-icons/fi";
import {Link} from "react-router-dom";
import AuthLayout from "../../components/Layouts/AuthLayout";
import {RouteNames} from "../../constants";
import SuccessIcon from "../../assets/icons/thumbs-up-success.png";

const ForgetPassword = () => {
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [passwordUpdateSuccess, setPasswordUpdateSuccess] = useState(true);

    const submitForgetPasswordForm = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setPasswordUpdateSuccess(true);
    }

    return (
        <AuthLayout>
            <div className="login forget-password">
                <div className="flex justify-end">
                    <Link to={RouteNames.LOGIN} className="btn btn-outline">
                        <FaSignInAlt className="mr-2"/>
                        Login
                    </Link>
                </div>
                {!passwordUpdateSuccess ?

                    <div className="login_form">
                        <button className="btn btn-text">
                            <FaArrowLeft className="mr-2"/>
                            Back
                        </button>
                        <h1 className="login_form_head">
                            Reset Password
                        </h1>
                        <div className="login_form_text">
                            Enter new login password
                        </div>
                        <form className="pb-8" onSubmit={submitForgetPasswordForm}>
                            <div className="input_container">
                                <label className="input_title" htmlFor="password">
                                    Password
                                </label>
                                <div className="input_password_cage">
                                    <input
                                        id={"password"}
                                        className="input_field"
                                        type={!showPassword ? "password" : "text"}
                                        placeholder={"Enter password"}
                                    />
                                    <span onClick={() => setShowPassword(!showPassword)}>
                                    {showPassword ? <FiEye/> : <FiEyeOff/>}
                                </span>
                                </div>
                            </div>
                            <div className="input_container">
                                <label className="input_title" htmlFor="password">
                                    Password
                                </label>
                                <div className="input_password_cage">
                                    <input
                                        id={"password"}
                                        className="input_field"
                                        type={!showConfirmPassword ? "password" : "text"}
                                        placeholder={"Enter password"}
                                    />
                                    <span onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                                    {showConfirmPassword ? <FiEye/> : <FiEyeOff/>}
                                </span>
                                </div>
                            </div>

                            <button className="btn btn-primary btn-primary-full" type="submit">
                                Update
                            </button>
                        </form>
                    </div>
                    :
                    <div className="password_updated">
                        <img src={SuccessIcon} alt=""/>
                        <div className="password_updated_head">
                            Password update completed.
                        </div>
                        <div className="password_updated_text">
                            Your password has been update, continue login.
                        </div>
                        <div className="flex justify-center mt-10">
                            <Link to={RouteNames.LOGIN} className="btn btn-primary btn-b mx-auto">
                                Login to Continue
                            </Link>
                        </div>

                    </div>
                }
            </div>
        </AuthLayout>
    )
}

export default ForgetPassword;